import React from 'react'
import ServiceDetails from '../Components/ServiceDetails/ServiceDetails'
import FacadeImg from '../Assests/Images/carousal-pest.jpg'

export default function ServicePestControl() {
    return (
        <>
            <ServiceDetails
                ServiceName={"Pest Control"}
                Description={"Take back control of your home or business and enjoy peace of mind with our premier pest control services. At SaafSafaiWale, we understand the frustration and inconvenience that unwelcome pests can bring to your life. Our team of highly trained experts is dedicated to eradicating pests from your premises, ensuring a safe and comfortable environment for you, your family, or your employees. With our cutting-edge techniques and eco-friendly solutions, we not only eliminate existing infestations but also prevent future invasions. Don't let pests compromise your comfort and well-being. Choose SaafSafaiWale for a pest-free future and protect what matters most. Let us be your shield against the invaders, so you can live and work worry-free. Your peace of mind is our priority, and our pest control services are the solution you've been looking for."}
                ServiceImage={<img src={FacadeImg} alt='Facade Cleaning'></img>} />

        </>
    )
}
